var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19C12 20.6569 10.6569 22 9 22C7.34315 22 6 20.6569 6 19C6 17.3431 7.34315 16 9 16C10.6569 16 12 17.3431 12 19Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4377 19.75C13.4786 19.5061 13.4999 19.2555 13.4999 19C13.4999 18.7445 13.4786 18.4939 13.4377 18.25H21.9999C22.4141 18.25 22.7499 18.5858 22.7499 19C22.7499 19.4142 22.4141 19.75 21.9999 19.75H13.4377Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56222 19.75H2C1.58579 19.75 1.25 19.4142 1.25 19C1.25 18.5858 1.58579 18.25 2 18.25H4.56222C4.5213 18.4939 4.5 18.7445 4.5 19C4.5 19.2555 4.5213 19.5061 4.56222 19.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H20C21.1046 2 22 2.89543 22 4V12C22 13.1046 21.1046 14 20 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89543 2 4 2ZM10.7822 10.9214L14.7597 8.43383C15.0801 8.23346 15.0801 7.76654 14.7597 7.56617L10.7822 5.07858C10.4417 4.86561 10 5.11059 10 5.51241V10.4876C10 10.8894 10.4417 11.1344 10.7822 10.9214Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayback);
export default __webpack_public_path__ + "static/media/video-playback.d44c09a8da6b12da74cb588d601b9c04.svg";
export { ForwardRef as ReactComponent };